import styled from "styled-components";

import * as Table from "ds/Table";

export const Container = styled.div``;
export const Tr = styled(Table.Tr)<{ highlighted: boolean }>`
  height: fit-content;
  box-shadow: none !important;

  background-color: ${({ highlighted }) =>
    highlighted
      ? "var(--section-color-primary-100-background-color, var(--color-primary-100))"
      : "none"};
`;

export const Progress = styled.div`
  position: relative;
  height: 32px;
  width: 100%;
  line-height: 0;

  border-radius: 5px;

  background-color: var(--theme-neutral-100);

  overflow: hidden;
`;

const ProgressBar = styled.div`
  position: absolute;
  height: 32px;
  margin: 0;
  padding: 0;
`;

export const ProgressBarInclusive = styled(ProgressBar)`
  z-index: 1;
  background-color: var(--profile-type-light-color);
`;

export const ProgressBarExclusive = styled(ProgressBar)`
  z-index: 2;
  background-color: var(--profile-type-color);
`;
